import { render, staticRenderFns } from "./GlobalSetup.vue?vue&type=template&id=35313369"
import script from "./GlobalSetup.vue?vue&type=script&lang=js"
export * from "./GlobalSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports